<template>
	<AtomForm
		v-if="!isFormSent"
		:action="LeadFormWebhooksEnum.PT"
		:is-submitting="isFormSubmitting"
		:is-success="isFormSent"
		:is-error="isFormFailed"
		submit-button-text="Personal Training informatie aanvragen"
		submit-button-icon="fa-dumbbell"
		:is-next-step-disabled="isNextStepDisabled"
		@submit="submit"
	>
		<div class="grid grid-cols-2 gap-x-8">
			<AtomInputText
				v-model="firstName"
				name="first-name"
				title="Voornaam"
				is-required
			/>
			<AtomInputText
				v-model="lastName"
				name="last-name"
				title="Achternaam"
				is-required
			/>
			<AtomInputEmail
				v-model="email"
				class="col-span-2"
				name="email"
				title="E-mailadres"
				is-required
			/>
			<AtomInputPhone
				v-model="phone"
				class="col-span-2"
				name="phone"
				title="Telefoonnummer"
				is-required
			/>
			<AtomInputRadioGroup
				v-model="trainingType"
				class="col-span-2"
				name="training-type"
				title="Type training"
				is-required
				:options="trainingTypeOptions"
			/>
		</div>
	</AtomForm>
	<Confirmation
		v-if="isFormSent"
		:email
		:first-name
		:last-name
	/>
</template>

<script lang="ts" setup>
import Confirmation from './FormLeadConfirmation.vue';
import isValidEmailAddress from '#base/helpers/validators/isValidEmailAddress';
import isValidPhoneNumber from '#base/helpers/validators/isValidPhoneNumber';
import leadFormSubmit from '#base/helpers/leadFormSubmit';
import { LeadFormWebhooksEnum } from '#fit/core/enums/LeadFormWebhooksEnum';
import { LeadFormProductsEnum } from '#fit/core/enums/LeadFormProductsEnum';
import { ConversionValuesEnum } from '#fit/core/enums/ConversionValuesEnum';

const eventTracking = useEventTracking();

const firstName = ref<string>();
const lastName = ref<string>();
const email = ref<string>();
const phone = ref<string>();
const trainingType = ref<string>('Personal Training');

const trainingTypeOptions = [
	'Personal Training',
	'Duo Training',
];

const isDuo = computed(() => trainingType.value === 'Duo Training');

const productName = computed(() =>
	isDuo.value ? LeadFormProductsEnum.Duo : LeadFormProductsEnum.PT,
);

const conversionValue = computed(() =>
	isDuo.value ? ConversionValuesEnum.Duo : ConversionValuesEnum.PT,
);

const isFormSent = ref(false);
const isFormFailed = ref(false);
const isFormSubmitting = ref(false);

watch([firstName, lastName, email, phone, trainingType], () => {
	if (!isFormSubmitting.value) {
		isFormSent.value = false;
		isFormFailed.value = false;
		isFormSubmitting.value = false;
	}
});

const isNextStepDisabled = computed(() => {
	return !firstName.value
		|| !lastName.value
		|| !email.value || !isValidEmailAddress(email.value)
		|| !phone.value || !isValidPhoneNumber(phone.value)
		|| !trainingType.value;
});

function submit(e: FormDataEvent) {
	e.preventDefault();

	isFormSubmitting.value = true;

	eventTracking.trackLeadFormSubmit(
		'pt',
		conversionValue.value,
	);

	leadFormSubmit(LeadFormWebhooksEnum.PT, {
		firstName: firstName.value ?? '-',
		lastName: lastName.value ?? '-',
		email: email.value ?? '-',
		phone: phone.value ?? '-',
		product: productName.value,
	})
		.then(() => {
			isFormSent.value = true;
			isFormFailed.value = false;
		})
		.catch(() => {
			isFormSent.value = false;
			isFormFailed.value = true;
		})
		.finally(() => {
			isFormSubmitting.value = false;
		});
}
</script>
